export const SHOW_SATURDAY = 'Show Saturday';
export const HIDE_SATURDAY = 'Hide Saturday';
export const SHOW_SUNDAY = 'Show Sunday';
export const HIDE_SUNDAY = 'Hide Sunday';
